module.exports = __webpack_public_path__ + "static/media/avatar3.7ed3a371.png";